<!-- 対象者区分マスタ　新規登録画面 -->
<style src="@/assets/css/admin_parts.css" type="text/css" media="all" scoped></style>
<template>
	<div class="contents" id="whfkb">
		<!-- ▽  -->
		<section id="mainContent">
			<h2>対象者区分マスタ<span>新規</span></h2>
			<ul class="contntMenu">
				<li class="onCancel" v-on:click="onCancel">戻る</li>
			</ul>
			<!-- ▽  -->
			<section class="inputArea">
				<div class="btnLst">
					<button class="confBtn" v-on:click="onConfirmRegisterModalOpen">登録</button>
				</div>
				<table class="inputTbl">
					<thead>
						<tr>
							<th>項目名称</th>
							<th>登録内容</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<th>名称</th>
							<td><input type="text" v-model="kbnm" placeholder="名称"></td>
						</tr>
					</tbody>
				</table>
			</section>
			<!-- △  END -->
		</section>
		<!-- △ mainContents END -->
		<!-- モーダルWindow S -->
		<modalWindow v-show="modal.validationError.isShow" v-on:close="onValidationErrorModalClose">
			<dt slot="modal-header">入力エラー</dt>
			<dd slot="modal-body">
				<errorMessageBox :errorMessages="modal.validationError.messages"></errorMessageBox>
			</dd>
			<dd slot="modal-footer"><a href="javascript:void(0)" v-on:click="onValidationErrorModalClose">閉じる</a></dd>
		</modalWindow>
		<!-- モーダルWindow E -->
		<!-- モーダルWindow S -->
		<modalWindow v-show="modal.systemError.isShow" v-on:close="onSystemErrorModalClose">
			<dt slot="modal-header">システムエラー</dt>
			<dd slot="modal-body">
				<errorMessageBox :errorMessages="modal.systemError.messages"></errorMessageBox>
			</dd>
			<dd slot="modal-footer"><a href="javascript:void(0)" v-on:click="onSystemErrorModalClose">閉じる</a></dd>
		</modalWindow>
		<!-- モーダルWindow E -->
		<modalWindow v-show="modal.confirmRegister.isShow" v-on:close="onConfirmRegisterModalClose">
			<dt slot="modal-header">確認</dt>
			<dd slot="modal-body">
				<errorMessageBox :errorMessages="modal.confirmRegister.messages"></errorMessageBox>
				<ul class="btnLst">
					<li><button v-on:click="onRegister">OK</button></li>
					<li><button v-on:click="onConfirmRegisterCancel">キャンセル</button></li>
				</ul>
			</dd>
		</modalWindow>
		<!-- モーダルWindow E -->
	</div>
</template>

<script>
	import { WHFKBRegisterApi } from '@/api'
	import * as ErrorCodes from '@/components/Utility/error-codes'
	import ErrorMessageBox from '@/components/Utility/ErrorMessageBox'
	import ModalWindow from '@/components/Utility/ModalWindow'
  import * as UtilityConsoleLog from '@/components/Utility/UtilityConsoleLog'

	export default {
		name: 'MasterWHFKBRegister',
		// 使用コンポーネント
		components: {
			// エラーメッセージ
			errorMessageBox: ErrorMessageBox,
			// モーダルウィンドウ
			modalWindow: ModalWindow
		},
		data() {
			return {
				kbnm: '',
				// モーダルウィンドウ
				modal: {
					validationError: {
						messages: [],
						isShow: false
					},
					systemError: {
						messages: [
							'システムエラーです。',
							'内容をもう一度ご確認ください。'
						],
						isShow: false
					},
					confirmRegister: {
						messages:[
							'登録しますか？'
						],
						isShow: false
					},
				}
			}
		},
		methods: {
			onRegister: function () {
				UtilityConsoleLog.consoleLog("MasterWHFKBRegister::onRegister Start")

				var tempircd = this.$store.state.auth.ircd
				var tempjgcd = this.$store.state.adminUserChoice.MasterWJGYO.jgcd
				var tempkbnm = this.kbnm

				WHFKBRegisterApi.Register({
					token: this.$store.state.auth.token,
					ircd: tempircd,
					jgcd: tempjgcd,          
					kbnm: tempkbnm
				}).then(({ responce }) => {

					if (responce.data.errorCode == ErrorCodes.ERRORCODE_DEFAULT) {

						//登録確認モーダルを閉じる
						this.onConfirmRegisterModalClose()
						//登録完了モーダルを開く
						this.$router.push("/MasterWHFKBRegisterDone")

					} else if (responce.data.errorCode == ErrorCodes.ERRORCODE_SIMPLEITEM
						|| responce.data.errorCode == ErrorCodes.ERRORCODE_SYSTEM
						|| responce.data.errorCode == ErrorCodes.ERRORCODE_DB) {
						// システム、DBエラー時
						this.onSystemErrorModalOpen()
					} else if (responce.data.errorCode == ErrorCodes.ERRORCODE_INPUTSIMPLEITEM) {
						//入力項目でのエラー
						this.onValidationErrorModalOpen(responce.data.errorMessagesList)
					}
					
				}).catch(() => {
					// システムエラー時
					this.onSystemErrorModalOpen()
				}).finally(() => {
					UtilityConsoleLog.consoleLog('MasterWHFKBRegister::onRegister End')
				})
			},
			//一覧表示画面に戻る
			onCancel: function () {
				UtilityConsoleLog.consoleLog("MasterWHFKBRegister::onCancel Start")

				this.$router.push("/MasterWHFKBList")

				UtilityConsoleLog.consoleLog("MasterWHFKBRegister::onCancel End")
			},
			// バリデーションエラーモーダルとしてエラーモーダルを開く
			// errorMessagesは文字列配列であること
			// errorMessages = [
			//  'エラーメッセージ'
			// ]
			onValidationErrorModalOpen: function (errorMessages) {
				UtilityConsoleLog.consoleLog('MasterWHFKBRegister::onValidationErrorModalOpen Start')

				var tempMessages = [
					'入力エラーです。',
					'以下の内容をもう一度ご確認ください'
				]
				
				errorMessages.forEach((item)=>{
					tempMessages.push(item)
				})
				this.modal.validationError.messages = tempMessages
				this.modalOpen('validationError')

				UtilityConsoleLog.consoleLog('MasterWHFKBRegister::onValidationErrorModalOpen End')
			},
			// バリデーションエラーモーダルとしてエラーモーダルを閉じる
			onValidationErrorModalClose: function () {
				UtilityConsoleLog.consoleLog('MasterWHFKBRegister::onValidationErrorModalClose Start')

				this.modalClose('validationError')

				UtilityConsoleLog.consoleLog('MasterWHFKBRegister::onValidationErrorModalClose End')
			},
			// システムエラーモーダルとしてエラーモーダルを開く
			onSystemErrorModalOpen: function () {
				UtilityConsoleLog.consoleLog('MasterWHFKBRegister::onSystemErrorModalOpen Start')

				this.modalOpen('systemError')

				UtilityConsoleLog.consoleLog('MasterWHFKBRegister::onSystemErrorModalOpen End')
			},
			// システムエラーモーダルウィンドウの閉じるボタン
			onSystemErrorModalClose: function () {
				UtilityConsoleLog.consoleLog('MasterWHFKBRegister::onSystemErrorModalClose Start')

				this.modalClose('systemError')
				this.$router.push("/AdminLogin")

				UtilityConsoleLog.consoleLog('MasterWHFKBRegister::onSystemErrorModalClose End')
			},
			// 登録確認モーダルを開く
			onConfirmRegisterModalOpen: function () {
				UtilityConsoleLog.consoleLog('MasterWHFKBRegister::onConfirmRegisterModalOpen Start')

				this.modalOpen('confirmRegister')

				UtilityConsoleLog.consoleLog('MasterWHFKBRegister::onConfirmRegisterModalOpen End')
			},
			// 登録確認モーダルを閉じる
			onConfirmRegisterModalClose: function () {
				UtilityConsoleLog.consoleLog('MasterWHFKBRegister::onConfirmRegisterModalClose Start')

				this.modalClose('confirmRegister')

				UtilityConsoleLog.consoleLog('MasterWHFKBRegister::onConfirmRegisterModalClose End')
			},
			// 登録確認モーダルで表示画面に戻る
			onConfirmRegisterCancel: function () {
				UtilityConsoleLog.consoleLog("MasterWHFKBRegister::onConfirmRegisterCancel Start")

				this.modalClose('confirmRegister')

				UtilityConsoleLog.consoleLog("MasterWHFKBRegister::onConfirmRegisterCancel End")
			},
			// モーダルウィンドウを開く
			modalOpen: function (modalName) {
				UtilityConsoleLog.consoleLog('MasterWHFKBRegister::modalOpen Start')

				// すべてのモーダルを閉じる
				this.allModalClose()

				this.modal[modalName].isShow = true

				UtilityConsoleLog.consoleLog('MasterWHFKBRegister::modalOpen End')
			},
			// モーダルウィンドウを閉じる
			modalClose: function (modalName) {
				UtilityConsoleLog.consoleLog('MasterWHFKBRegister::modalClose Start')

				this.modal[modalName].isShow = false

				UtilityConsoleLog.consoleLog('MasterWHFKBRegister::modalClose End')
			},
			// 全てのモーダルを閉じる
			allModalClose: function() {  
				for(var key in this.modal) {
					this.modal[key].isShow = false
				}
			}
		}
	}</script>



// WEBPACK FOOTER //
// src/components/Admin/Master/WJGYO/MasterWHFKBRegister.vue